import type { ReactNode } from 'react';

export const symbol_battery_charging_80: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M310-80q-12.75 0-21.37-8.63Q280-97.25 280-110v-676q0-12.75 8.63-21.38Q297.25-816 310-816h90v-34q0-12.75 8.63-21.38Q417.25-880 430-880h100q12.75 0 21.38 8.62Q560-862.75 560-850v34h90q12.75 0 21.38 8.62Q680-798.75 680-786v313q0 7.97-5.93 13.76-5.92 5.79-14.07 7.24-38 4-71 20.03-33 16.02-58.67 41.66Q501-361 484-322.54q-17 38.45-17 83.54 0 35 11 66.5t30 57.5q8 11 2.5 23T492-80H310Zm30-476h280v-200H340v200Zm320 356h-53q-9.39 0-13.7-7.5-4.3-7.5.7-15.5l92-147q3-5 8.5-3.5t5.5 7.5v86h53q9.39 0 13.7 7.5 4.3 7.5-.7 15.5l-92 148q-3 5-8.5 3.5T660-113v-87Z"
		/>
	</svg>
);
